<template>

	<span
		v-b-tooltip.hover :title="hover_text" 
		class="btn-text btn-sm pointer p-1 mr-1" 
		:class="classtext"
		@click="postPin()"
	>
		<i class="fas fa-thumbtack"></i> <span v-text="text"></span>
	</span>

</template>

<script>
import axios from "axios";
export default {
	name: 'PostPin',
		props: {
			status: String,
			type: String,
			id: String,
			highlight: { type: String, default: 'gold', },
		},
		data() {
			return {
				status_use: null,
				text: '',
				hover_text: '',
			}
		},
		computed: {
		},
		created(){
			this.status_use = parseInt(this.status);
			this.setPin();
		},
		methods:{
			postPin(){
				let _this = this;
				
				console.log('postPin');
	
				let params = new URLSearchParams();
				params.append('token', this.$store.state.session_id);
				params.append('type', this.type);
				params.append('id', this.id);
	
				axios({
					method: 'post',
					url: _this.$store.state.api_url + "forum/postPin",
					data: params,
	
				}).then(function (response) {
					if(response.data.status == 1){
						_this.status_use = !_this.status_use;
						_this.setPin();
					}
					
				}).catch(function (error) {
					console.log(error);
				});
			},
			setPin(){
				this.text = (this.status_use == 0) ? 'pin' : 'un-pin';
				this.classtext = (this.status_use == 0) ? this.highlight : 'btn-danger';
				this.hover_text = (this.status == 0) ? 'Pin this to all users Dashboards' : 'Un-pin from all Dashboards';
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
